import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dd4cb6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "sync-op details panel bg-white",
  "data-testid": "syncOpDetails"
}
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-secondary" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "description text-body-light" }
const _hoisted_9 = { class: "reference row items-center" }
const _hoisted_10 = { class: "icon-round" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "is-hidden-above-small" }

import { computed, ref } from 'vue'
import { useGettext } from 'vue3-gettext'

import formatDate from '@/helpers/formatDate'
import IconUI from '@/components/CommonUI/IconUI.vue'
import ApplyDialog from './ApplyDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncOpDetails',
  props: {
    syncOp: {}
  },
  emits: ['close-modal'],
  setup(__props: any) {

const props = __props;

const { $gettext } = useGettext()
const currentLocale = useGettext().current

const applyDialog = ref<InstanceType<typeof ApplyDialog> | null>(null)




const deadline = computed(() => formatDate(props.syncOp.deadline, currentLocale))


return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("header", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.syncOp.banner?.contentUrl || 'https://placehold.co/900x200?text=No+Banner',
            alt: "sync opportunity banner"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.syncOp.logo?.contentUrl || 'https://placehold.co/100x100?text=No+Logo',
            alt: "sync opportunity logo"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("h2", null, _toDisplayString(_ctx.syncOp.title), 1),
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, [
            _createTextVNode(_toDisplayString(_unref($gettext)('Deadline')) + ": ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(deadline.value), 1)
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.syncOp.wasAppliedFor,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.syncOp.wasAppliedFor && applyDialog.value?.show()))
        }, _toDisplayString(_ctx.syncOp.wasAppliedFor ? _unref($gettext)('Already Applied') : _unref($gettext)('Apply')), 9, _hoisted_7)
      ]),
      _createElementVNode("p", null, [
        _withDirectives((_openBlock(), _createElementBlock("strong", null, [
          _createTextVNode("Details:")
        ])), [
          [_directive_translate]
        ])
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.syncOp.description), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(IconUI, { name: "headset" })
        ]),
        _withDirectives((_openBlock(), _createElementBlock("p", null, [
          _createTextVNode(" Reference: ")
        ])), [
          [_directive_translate]
        ]),
        _createElementVNode("a", {
          class: "reference-link truncate-line text-body",
          href: _ctx.syncOp.reference,
          target: "_blank",
          rel: "noopener noreferrer"
        }, _toDisplayString(_ctx.syncOp.referenceTitle || _ctx.syncOp.reference), 9, _hoisted_11)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.syncOp.keywords, (keyword) => {
        return (_openBlock(), _createElementBlock("strong", {
          key: keyword.trim(),
          title: keyword,
          class: "tag"
        }, _toDisplayString(keyword), 9, _hoisted_12))
      }), 128)),
      _createElementVNode("footer", _hoisted_13, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "is-hidden-above-small full-width back-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-modal')))
        }, [
          _createTextVNode(" Back to Sync Opportunities ")
        ])), [
          [_directive_translate]
        ])
      ])
    ]),
    _createVNode(ApplyDialog, {
      ref_key: "applyDialog",
      ref: applyDialog,
      "sync-op": _ctx.syncOp,
      "data-testid": "applyDialog"
    }, null, 8, ["sync-op"])
  ], 64))
}
}

})